
















import { Component, Vue } from 'vue-property-decorator';
import api_client from '../lib/api_client';

@Component
export default class Home extends Vue {
  public form = {};

  public async submit() {
    await api_client.post('/players', { player: this.form });
    this.$store.commit('setAlert', {
      type: 'info',
      text: 'Thanks for signing up. You can now log in.',
    });
    this.$router.push({ name: 'login' });
  }
}
